// extracted by mini-css-extract-plugin
module.exports = {"event":"Ak0b6","date":"_2alFZ","map":"_1FOLI"};